import { render, staticRenderFns } from "./ActivityModal.vue?vue&type=template&id=37604baf&"
import script from "./ActivityModal.vue?vue&type=script&lang=js&"
export * from "./ActivityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports